import Flickity from "flickity";

class News {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-news-section="scope"]',
			button: '[data-news-section="button"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('click', this.config.button, this.slide.bind(this));
	}

	slide(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		let $scope = $button.closest(this.config.scope);
		let $flickity = $scope.find('.flickity-carousel');
		let flickity = Flickity.data($flickity[0]);

		if($button.data('direction') == 'next') {
			flickity.next();
		} else {
			flickity.previous();
		}
	}
}

export default new News;